import React from 'react';
import { PostType } from '../../interfaces';
// eslint-disable-next-line import/no-extraneous-dependencies
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  EmailShareButton,
  EmailIcon,
  TelegramShareButton,
  TelegramIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from "react-share";

export const DesktopShare = ({
  data,
}: {
  data: PostType | undefined;
}) => {
  return (
    data?.read_more_link ? <div className="flex flex-column justify-start items-center z-10">
      <div className="mb-4">
        <FacebookShareButton
          className='mb-2 lg:opacity-40 hover:opacity-100 transition-opacity'
          url={data?.read_more_link}>
          <FacebookIcon size={32} round />
        </FacebookShareButton>
        <TwitterShareButton
          className='mb-2 lg:opacity-40 hover:opacity-100 transition-opacity'
          url={data?.read_more_link}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <EmailShareButton
          className='mb-2 lg:opacity-40 hover:opacity-100 transition-opacity'
          url={data?.read_more_link}>
          <EmailIcon size={32} round />
        </EmailShareButton>
        <TelegramShareButton
          className='mb-2 lg:opacity-40 hover:opacity-100 transition-opacity'
          url={data?.read_more_link}>
          <TelegramIcon size={32} round />
        </TelegramShareButton>
        <WhatsappShareButton
          className='lg:opacity-40 hover:opacity-100 transition-opacity'
          url={data?.read_more_link}>
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </div>
    </div>
      : null);
};